import React from 'react';
import { useState } from 'react'



import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
  } from "reactstrap";



function CustomProgramPicker(props){
    //const [picker1,setPicker1] = useState('Aerobic')
    //const [picker2,setPicker2] = useState('Aerobic')
    //const [picker3,setPicker3] = useState('Aerobic')
    //const [picker4,setPicker4] = useState('Aerobic')

    
    //console.log(props)

    return (
        <>  
        
            <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <FormGroup>
                        <label>Month 1</label>
                        <Input id ={1} onChange={e =>props.pickerChange(e.target.value,e.target.id)} value={props.picker1} type="select" style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                            <option value={'Base'}>Base</option>
                            <option value={'Aerobic'}>Aerobic</option>
                            <option value={'LongRun-Aerobic'}>LongRun-Aerobic</option>
                            <option value={'Aerobic-Tempo'}>Aerobic-Tempo</option>
                            <option value={'Easy-LongRun-Tempo'}>Easy-LongRun-Tempo</option>
                            <option value={'LongRun-Interval-Easy'}>LongRun-Interval-Easy</option>  
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <FormGroup>
                        <label>Month 2</label>
                        <Input id ={2} onChange={e =>props.pickerChange(e.target.value,e.target.id)} value={props.picker2} type="select" style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                            <option value={'Base'}>Base</option>
                            <option value={'Aerobic'}>Aerobic</option>
                            <option value={'LongRun-Aerobic'}>LongRun-Aerobic</option>
                            <option value={'Aerobic-Tempo'}>Aerobic-Tempo</option>
                            <option value={'Easy-LongRun-Tempo'}>Easy-LongRun-Tempo</option>
                            <option value={'LongRun-Interval-Easy'}>LongRun-Interval-Easy</option>  
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <FormGroup>
                        <label>Month 3</label>
                        <Input id ={3} onChange={e =>props.pickerChange(e.target.value,e.target.id)} value={props.picker3} type="select" style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                            <option value={'Base'}>Base</option>
                            <option value={'Aerobic'}>Aerobic</option>
                            <option value={'LongRun-Aerobic'}>LongRun-Aerobic</option>
                            <option value={'Aerobic-Tempo'}>Aerobic-Tempo</option>
                            <option value={'Easy-LongRun-Tempo'}>Easy-LongRun-Tempo</option>
                            <option value={'LongRun-Interval-Easy'}>LongRun-Interval-Easy</option>  
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <FormGroup>
                        <label>Month 4</label>
                        <Input id ={4} onChange={e =>props.pickerChange(e.target.value,e.target.id)} value={props.picker4} type="select" style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                            <option value={'Base'}>Base</option>
                            <option value={'Aerobic'}>Aerobic</option>
                            <option value={'LongRun-Aerobic'}>LongRun-Aerobic</option>
                            <option value={'Aerobic-Tempo'}>Aerobic-Tempo</option>
                            <option value={'Easy-LongRun-Tempo'}>Easy-LongRun-Tempo</option>
                            <option value={'LongRun-Interval-Easy'}>LongRun-Interval-Easy</option>  
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
           
        </>
    )
}

export default CustomProgramPicker;